import { render, staticRenderFns } from "./ProductTypeEdit.vue?vue&type=template&id=5b32b702&"
import script from "./ProductTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ProductTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports